module.exports = __webpack_public_path__ + "static/media/Check File icon 2.cf710606.svg";